var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgWIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 21 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.2031 0.832592L16.7091 14.6595C16.6142 15.0076 16.2502 15.389 15.9025 15.389H13.6574C13.2937 15.389 12.9457 14.9882 12.8509 14.6404L10.5742 5.02788L8.24975 14.6693C8.17075 15.0171 7.80732 15.389 7.45936 15.389H5.24586C4.8821 15.389 4.51867 14.9882 4.43966 14.6404L0.992672 0.890887C0.897864 0.542762 1.13521 0.23877 1.48284 0.23877H3.96529C4.32872 0.23877 4.67668 0.484466 4.73989 0.848401L6.57416 10.4625L8.91407 0.850377C8.99307 0.502251 9.35683 0.23877 9.70446 0.23877H11.6335C11.997 0.23877 12.3449 0.4927 12.4401 0.840496L14.7958 10.4586L16.6142 0.855976C16.6771 0.50818 17.0251 0.23877 17.3727 0.23877H19.7129C20.0764 0.23877 20.2979 0.484466 20.2031 0.832592Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWIcon);
export default __webpack_public_path__ + "static/media/wIcon.25a1d74d.svg";
export { ForwardRef as ReactComponent };